import FinancialChannelRepository from "../repository/financial-channel-repository";

class FinancialChannelService
{
    #financialChannelRepository;

    constructor() {
        this.#financialChannelRepository = new FinancialChannelRepository();
    }

    async findAll() {
        try {
            const data = await this.#financialChannelRepository.getAll();

            return data;
        } catch (error) {
            console.error(error);
        }
    }
}

export default FinancialChannelService;